/**
 * Phase 8a.2.3 — five canonical profile fixtures used by the scoring-rubric
 * what-if preview. These are deterministic so the engine-parity test
 * (Python vs JS engine) can compare outputs byte-for-byte.
 *
 * Each profile mirrors the fields `Profile` reads in
 * `backend/modules/readiness/engine.py`. Loosely paired with the credit-report
 * scenarios in /app/memory/test_data/ but designed to exercise rubric edges.
 */

"use strict";

const SCENARIOS = [
  {
    id: "S1",
    label: "Jordan Test — Repair Required",
    summary: "Subprime credit (520), multiple recent lates, no business.",
    profile: {
      first_name: "Jordan",
      last_name: "Test",
      is_business_owner: false,
      has_existing_business: false,
      estimated_credit_score: 520,
      estimated_credit_score_unknown: false,
      self_reported_payment_history: "multiple_recent",
      effective_payment_history: null,
      funding_purpose: "Other",
      funding_goal_amount: null,
      business_structure: null,
      has_ein: false,
      has_business_bank_account: false,
      time_in_business_months: 0,
      monthly_revenue: null,
    },
  },
  {
    id: "S2",
    label: "Riley Test — Almost Ready (startup)",
    summary: "Fair credit (640), older lates, clear startup goal.",
    profile: {
      first_name: "Riley",
      last_name: "Test",
      is_business_owner: false,
      has_existing_business: false,
      estimated_credit_score: 640,
      estimated_credit_score_unknown: false,
      self_reported_payment_history: "older_than_48_months",
      effective_payment_history: null,
      funding_purpose: "working_capital",
      funding_goal_amount: 12000,
      business_structure: null,
      has_ein: false,
      has_business_bank_account: false,
      time_in_business_months: 0,
      monthly_revenue: null,
    },
  },
  {
    id: "S3",
    label: "Morgan Test — Funding Ready (startup)",
    summary: "Very-good credit (720), no lates, full prep.",
    profile: {
      first_name: "Morgan",
      last_name: "Test",
      is_business_owner: false,
      has_existing_business: false,
      estimated_credit_score: 720,
      estimated_credit_score_unknown: false,
      self_reported_payment_history: "none_48_months",
      effective_payment_history: null,
      funding_purpose: "equipment",
      funding_goal_amount: 30000,
      business_structure: null,
      has_ein: false,
      has_business_bank_account: false,
      time_in_business_months: 0,
      monthly_revenue: null,
    },
  },
  {
    id: "S4",
    label: "Alex Test — Established LLC, mid revenue",
    summary: "LLC, EIN, 18mo, $14k/mo, 685 credit.",
    profile: {
      first_name: "Alex",
      last_name: "Test",
      is_business_owner: true,
      has_existing_business: true,
      estimated_credit_score: 685,
      estimated_credit_score_unknown: false,
      self_reported_payment_history: "older_than_48_months",
      effective_payment_history: null,
      funding_purpose: "expansion",
      funding_goal_amount: 75000,
      business_structure: "llc",
      has_ein: true,
      has_business_bank_account: true,
      time_in_business_months: 18,
      monthly_revenue: 14000,
    },
  },
  {
    id: "S5",
    label: "Casey Test — Established LLC, strong revenue",
    summary: "LLC, EIN, 36mo, $22k/mo, 705 credit, no lates.",
    profile: {
      first_name: "Casey",
      last_name: "Test",
      is_business_owner: true,
      has_existing_business: true,
      estimated_credit_score: 705,
      estimated_credit_score_unknown: false,
      self_reported_payment_history: "none_48_months",
      effective_payment_history: null,
      funding_purpose: "expansion",
      funding_goal_amount: 100000,
      business_structure: "llc",
      has_ein: true,
      has_business_bank_account: true,
      time_in_business_months: 36,
      monthly_revenue: 22000,
    },
  },
];

module.exports = { SCENARIOS };
